<template>
  <section class="about-us">
    <div class="row p-4">
      
      <div class="col-6">
        <img class="float-lg-right" src="@/assets/33.jpg" />
      </div>
      <div class="col-sm-6 text-sm-left text-md-left">
        <h1>Mão Na Roda</h1>
        <h6>
          Você que precisa das mais diversas ferramentas e vai usar apenas uma vez, pode contar
          com a nossa seleção de ferramentas e equipamentos disponíveis para aluguel.
          <br /><br />

          Além do benefício de poder contar com ferramentas e equipamentos de qualidade, você ainda se 
          livra de ter que gastar um bom dinheiro em algo que na maioria das vezes fica guardado ocupando 
          um espaço na sua casa. <br /><br />

          Temos desde conjunto de chaves de fenda, furadeiras e parafusadeiras até caixas de ferramenta 
            completas. É a solução ideal para conseguir realizar todos os reparos, montar móveis, colocar 
            aquele quadro na parede.<br />
          <br />

          <b>Vem trasterar com a gente.</b>
        </h6>
      </div>
    </div>
    <!--<div class="row p-4 ">
      <div class="col-12 col-sm-6 text-sm-right text-md-right" style="margin-rigth: -5%">
        <h1>Não compre, reuse</h1>
        <h6>
          Imagine que ao invés de comprar um sofá, adereço de decoração, mesa de
          escritório, você pudesse alugar por um preço bem em conta, e ainda
          tendo a possibilidade de devolver o produto quando quiser.
          <br /><br />

          Além de todo o benefício que é ter a possibilidade de alugar uma
          infinidade de móveis, utensílios, ferramentas, etc, você ainda
          contribui para o consumo sustentável, o que ajuda bastante na
          preservação do meio ambiente. <br /><br />

          <b>E se você tem uma coisa parada em casa</b>, já imaginou dar um novo
          destino a ela ganhando um dinheiro extra e liberando o espaço em sua
          casa? <br />
          <br />

          <b>Vem trasterar com a gente.</b>
        </h6>
      </div>
      <div class="col-6">
        <img class="float-lg-right" src="@/assets/new.png" />
      </div>
    </div> -->
  </section>
</template>

<script>
export default {
  name: "AboutUs",
};
</script>

<style scoped>
.about-us img {
  width: 90%;
  min-width: 380px;
}
</style>
